export default __webpack_public_path__ + "static/media/onet.626110ae.png";